module.exports = __webpack_public_path__ + "img/image (10).ad710646.jpg";